/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
class Metrics {
    constructor() {
        this.grtRate = {
            value: 0
        };
        this.equipmentAvailability = {
            value: 0
        };
        this.failingEquipments = {
            value: 0
        };
        this.actionRequestsByStatus = [];
    }
}

export { Metrics };



// WEBPACK FOOTER //
// ./src/main/front/scripts/model/Metrics.js